import React, { useState, useEffect } from "react";
import ChangePassword from "./ChangePassword";
import useResponsiveFlags from "../hooks/useResponsiveFlags";
import WrapperContainer from "./utilities/WrapperContainer";
import { useAuth } from "../api/authUtils/AuthContext";
import LoadingGif from "../assests/images/loading.gif";
import axios from "../api/axios";

export default function Settings() {
  const { user } = useAuth();
  const { isDesktop } = useResponsiveFlags();
  const [activeType, setActiveType] = useState("profile");
  const [orgData, setOrgData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const handleTypeClick = (type) => {
    setActiveType(type);
  };
  const fetchData = async () => {
    axios
      .get("/api/get-user-org-details")
      .then((res) => {
        setOrgData(res.data.org);
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to load organisation detials");
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {/* Left Section: Instructions */}
      <WrapperContainer
        title={!isDesktop ? "Settings" : "Account Settings"}
        loggedin={true}
        buttons={
          <>
            <div className="buttons" data-toggle="buttons-radio">
              <button
                className={`menu-options px-4 ${
                  activeType === "profile" ? "btn-active" : "btn"
                }`}
                onClick={() => handleTypeClick("profile")}
              >
                <span>Profile</span>
              </button>
              <button
                className={`menu-options px-4 ${
                  activeType === "changePassword" ? "btn-active" : "btn"
                }`}
                onClick={() => handleTypeClick("changePassword")}
              >
                <span>Change Password</span>
              </button>
            </div>
            <div className="dropdown dropdown-buttons">
              <button
                className="btn dropdown-toggle"
                type="button"
                id="optionsMenu"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {activeType === "profile" ? "Profile" : "Change Password"}
              </button>
              <ul
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby="optionsMenu"
              >
                <li>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={() => handleTypeClick("profile")}
                  >
                    Profile
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={() => handleTypeClick("changePassword")}
                  >
                    Change Password
                  </a>
                </li>
              </ul>
            </div>
          </>
        }
        content={
          <>
            {activeType === "profile" && (
              <>
                <p className="mb-4 custom-title">Profile</p>
                {loading || error ? (
                  <div style={{ maxHeight: "98px" }}>
                    {loading && (
                      <img
                        src={LoadingGif}
                        alt="loading..."
                        style={{ maxHeight: "98px" }}
                      />
                    )}
                    {error && (
                      <span className="error-text custom-size">{error}</span>
                    )}
                  </div>
                ) : (
                  <>
                    <p className="custom-size">
                      Name: {user.fname} {user.lname}
                    </p>
                    <p className="custom-size">Organization: {orgData.name}</p>
                    <p className="custom-size">Org Code: {orgData.orgcode}</p>
                    <p className="custom-size">
                      Address: {orgData.address},{" "}{orgData.city},{" "}
                      {orgData.state}
                    </p>
                    <p className="custom-size">Country: {orgData.country}</p>
                  </>
                )}
              </>
            )}
            {activeType === "changePassword" && (
              <>
                <ChangePassword />
              </>
            )}
          </>
        }
      />
    </>
  );
}
